import ImageWithFallback from '@/components/atoms/ImageWithFallback';
import { TeamLeagueTeamsInfo } from '@/entities/TeamLeagueTeamsInfo';

interface StepTwoProps {
	teams: TeamLeagueTeamsInfo[];
	setSelectedTeam: (team: TeamLeagueTeamsInfo | undefined) => void;
	selectedTeam?: TeamLeagueTeamsInfo;
	teamId: string;
}
export function StepTwo({ teams, setSelectedTeam, selectedTeam, teamId }: StepTwoProps) {
	return (
		<div className="flex flex-col gap-6">
			<p className="text-darkorange-600">
				<span className="lg:hidden">Step 2:</span> Select the team that you want to make the trade with. In the next step, you will pick the
				players to trade.
			</p>
			{teams
				.filter((team) => team.uuid !== teamId)
				.map((team) => (
					<div
						key={team.uuid}
						onClick={() => setSelectedTeam(team)}
						className={`border ${selectedTeam?.uuid === team.uuid ? 'border-2 border-darkorange-400' : 'border-darkorange-50'} flex w-full max-w-[384px] cursor-pointer items-center gap-4 rounded-lg bg-violet-25 p-2 pl-4 text-sm font-semibold text-gray-900 shadow-md`}
					>
						<ImageWithFallback
							src={team.logo ? team.logo.url : '/assets/images/placeholder.png'}
							alt={team.title}
							fallbackSrc="/assets/images/placeholder.png"
							className="rounded object-cover w-[80px] h-[40px]"
							width={80}
							height={40}
						/>

						<p>{team.title}</p>
					</div>
				))}
		</div>
	);
}
